import React, { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Hidden, Grid, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import BareAppBar from './BareAppBar';

interface Props {
  main: ReactNode;
  image?: ReactNode;
}

const useStyles = makeStyles(theme => ({
  '@global html, body, #root': {
    height: '100%',
    background: theme.palette.common.white,
  },
  container: {
    height: '100%',
  },
  content: {
    flexGrow: 1,
  },
  reposition: {
    height: '100%',
    padding: theme.spacing(2),
  },
}));

const OnboardingLayout: FC<Props> = ({ image, main }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  function renderTermsLink() {
    return (
      <Link href="https://everyonesocial.com/user-terms-of-service" target="_blank">
        {t('auth:userTerms')}
      </Link>
    );
  }

  function renderPrivacyPolicyLink() {
    return (
      <Link href="https://everyonesocial.com/privacy-policy" target="_blank">
        {t('auth:privacyPolicy')}
      </Link>
    );
  }

  function renderContactLink() {
    return (
      <Link href="https://everyonesocial.com/contact" target="_blank">
        {t('auth:contactUs')}
      </Link>
    );
  }

  return (
    <Fragment>
      <BareAppBar />
      <div className={classes.reposition}>
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.container}
          wrap="nowrap"
        >
          <Grid
            item
            container
            spacing={4}
            justify="center"
            alignItems="center"
            className={classes.content}
          >
            {image && (
              <Hidden mdDown>
                <Grid item>{image}</Grid>
              </Hidden>
            )}
            <Grid item>{main}</Grid>
          </Grid>
          <Grid
            item
            container
            spacing={2}
            justify="center"
            alignItems="flex-end"
            alignContent="flex-end"
          >
            <Grid item>
              {renderTermsLink()} & {renderPrivacyPolicyLink()}
            </Grid>
            <Grid item>{renderContactLink()}</Grid>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default OnboardingLayout;
